import React, { Component } from "react";
import {
  CircularProgress,
  Grid,
  Button,
  Box,
  Autocomplete,
  TextField,
} from "@mui/material";
import { withRouter } from "react-router-dom";
import "./style.css";
import Datatable from "../CommonComponents/Datatable/Datatable";
import {
  getCustomers,
  addCustomer,
  editCustomer,
  toggleModal,
  toggleEditModal,
  handleChange,
  deleteCustomer,
} from "../../services/customerService";
import { getEmployees } from "../../services/employeeService";
import { toastAlert } from "../../helpers/toastAlert";
import { customerListData } from "../../helpers/renderData";
import BreadcrumbComp from "../CommonComponents/Breadcrumb/Breadcrumb";
import { connect } from "react-redux";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "../CommonComponents/RightDrawer";
import ConfirmDeleteModal from "../CommonComponents/Confrimationmodal";
import PasswordInput from "../CommonComponents/PasswordInput";
import ResetPasswordModal from "../CommonComponents/ResetPasswordModal";
import { resetCustomerPassword } from "../../services/customerService";
import { getTasks } from "../../services/taskService";
import { hasPermission } from "../../utils/commonutils";

class CustomerListComponent extends Component {
  constructor() {
    super();
    this.state = {
      _id: "",
      loading: true,
      tableData: {},
      page: 1,
      rowsPerPage: 10,
      count: 1,
      Searchtax: "",
      employeeData: [],
      showDeleteModal: false,
      resetPasswordTarget: null,
      Orderdata: [],
      deleteId: "",
      // Add Customer Value
      addModel: false,
      addError: [],
      addName: "",
      addEmail: "",
      addMobile: "",
      addGST: "",
      addPAN: "",
      addCompanyName: "",
      addOfficeAddr: "",
      addPassword: "",
      addEmployeeId: "",
      addTDS: "",

      // Edit Customer Value
      editModel: false,
      editError: [],
      editName: "",
      editEmail: "",
      editMobile: "",
      editGST: "",
      editPAN: "",
      editCompanyName: "",
      editOfficeAddr: "",
      editEmployeeId: "",
      UserId: "",
      editTDS: "",
    };
  }

  closeAddModal = () => {
    this.setState({
      addModel: false,
      addError: [],
      addName: "",
      addEmail: "",
      addMobile: "",
      addGST: "",
      addPAN: "",
      addCompanyName: "",
      addOfficeAddr: "",
      addPassword: "",
      addEmployeeId: "",
      addTDS: "",
    });
  };

  closeEditModal = () => {
    this.setState({
      editModel: false,
      editError: [],
      editName: "",
      editEmail: "",
      editMobile: "",
      editGST: "",
      editPAN: "",
      editCompanyName: "",
      editOfficeAddr: "",
      editEmployeeId: "",
      editTDS: "",
    });
  };

  itemArray = () => {
    return [
      {
        name: "All Customers",
        active: true,
        link: "",
      },
    ];
  };
  getTskdata = async () => {
    let tasks = await getTasks(this.props);
    const customerIdValues = Object?.values(tasks.data.tasks.tasks)?.map(
      (task) => task.customerId._id
    );
    if (tasks?.data?.tasks) {
      this?.setState({
        Orderdata: customerIdValues,
      });
    }
  };
  getCustomers = async (page, rowsPerPage, search) => {
    try {
      console.log("getCustomers function ", page, rowsPerPage, this.props);
      let customers = await getCustomers(this.props, page, rowsPerPage, search);
      if (customers && customers?.data?.customers !== null) {
        this.setState({
          count: customers?.data?.total,
          page: page,
        });
        let tableData = await customerListData(
          customers?.data?.customers,
          this
        );
        this.setState({
          tableData,
          loading: false,
        });
      } else {
        // error
        console.log(
          "error fetching customers : ",
          customers,
          customers?.message
        );
        let message =
          customers && customers?.message !== undefined
            ? customers?.message
            : "Problem Fetching Records.";
        toastAlert(message, "error");
        this.setState({ loading: false });
      }
    } catch (error) {
      console.log("error catch block", error);
      toastAlert("Please check Internet Connection.", "error");
      this.setState({ loading: false });
    }
  };

  getEmployees = async () => {
    try {
      let employees = await getEmployees(this.props, 1, 10000000000);
      console.log("getEmployees fetch data", employees);
      if (employees && employees?.data?.employees !== null) {
        this.setState({
          employeeData: employees?.data?.employees,
        });
      } else {
        // error
        console.log(
          "error fetching employees : ",
          employees,
          employees?.message
        );
        let message =
          employees && employees?.message !== undefined
            ? employees?.message
            : "Problem Fetching Records.";
        toastAlert(message, "error");
        this.setState({ loading: false });
      }
    } catch (error) {
      console.log("error catch block", error);
      toastAlert("Please check Internet Connection.", "error");
      this.setState({ loading: false });
    }
  };

  componentDidMount() {
    this.getCustomers(this.state.page, this.state.rowsPerPage);
    this.getEmployees();
    this.getTskdata();
  }

  addCustomer = async () => {
    const {
      addName,
      addEmail,
      addMobile,
      addPassword,
      addGST,
      addPAN,
      addCompanyName,
      addOfficeAddr,
      // addEmployeeId,
      addTDS,
    } = this.state;
    let error = [];

    if (!addName.trim()) {
      error.push("addName");
    }
    if (!addEmail.trim()) {
      error.push("addEmail");
    }
    if (!addMobile.trim()) {
      error.push("addMobile");
    }
    if (!addPassword.trim()) {
      error.push("addPassword");
    }
    // if (!addGST.trim()) {
    //   error.push("addGST");
    // }
    if (!/^[0-9]\d{9}$/.test(addMobile.trim()) && addMobile.trim()) {
      error.push("addmobileregx");
    }
    if (
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(addEmail.trim()) &&
      addEmail.trim()
    ) {
      error.push("addemailregx");
    }
    if (
      !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(
        addPassword.trim()
      ) &&
      addPassword.trim()
    ) {
      error.push("adddPasswordregx");
    }
    // if (!addPAN.trim()) {
    //   error.push("addPAN");
    // }
    if (!addCompanyName.trim()) {
      error.push("addCompanyName");
    }
    // if (!addTDS.trim()) {
    //   error.push("addTDS");
    // }
    // if (!addOfficeAddr.trim()) {
    //   error.push("addOfficeAddr");
    // }
    // console.log("employee Id:", addEmployeeId, error);
    // if (!addEmployeeId || !addEmployeeId?._id.trim()) {
    //   error.push("addEmployeeId");
    // }

    if (error.length > 0) {
      this.setState({
        addError: error,
      });
    } else {
      this.setState({
        addError: [],
      });
      try {
        console.log(" :->, Add Customer");
        let res = await addCustomer(this.props, this);
        console.log("Resolution", res.data, res.status);
        if (res && res?.status === 201) {
          toastAlert(
            res?.message ? res?.message : "customer added successfully",
            "success"
          );
          this.closeAddModal();
          this.getCustomers(this.state.page, this.state.rowsPerPage);
        } else {
          // error
          console.log("error adding customer : ", res, res.message);
          let message =
            res && res.message !== undefined
              ? res.message
              : "Problem while adding Records.";
          toastAlert(message, "error");
          this.closeAddModal();
        }
      } catch (error) {
        console.log("error catch block", error);
        toastAlert("Please check Internet Connection.", "error");
        this.closeAddModal();
      }
    }
  };

  editCustomer = async () => {
    const {
      editName,
      editEmail,
      editMobile,
      editmobileregx,
      editOfficeAddr,
    } = this.state;
    let error = [];

    if (!editName.trim()) {
      error.push("editName");
    }
    if (!editEmail.trim()) {
      error.push("editEmail");
    }
    const mobile = editMobile ? String(editMobile) : "";
    if (!String(mobile.trim())) {
      error.push("editMobile");
    }
    if (!/^[0-9]\d{9}$/.test(mobile.trim()) && mobile.trim()) {
      error.push("editmobileregx");
    }
    if (
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(editEmail) &&
      editEmail
    ) {
      error.push("editEmailregx");
    }
    // if (!editTDS.trim()) {
    //   error.push("editTDS");
    // }
    // if (!editPAN.trim()) {
    //   error.push("editPAN");
    // }
    // if (!editGST.trim()) {
    //   error.push("editGST");
    // }
    // if (!editOfficeAddr.trim()) {
    //   error.push("editOfficeAddr");
    // }
    if (error.length > 0) {
      this.setState({
        editError: error,
      });
    } else {
      this.setState({
        editError: [],
      });
      try {
        console.log(" :->, Edit Customer");
        let res = await editCustomer(this.props, this);
        console.log("Resolution", res);
        if ((res && res?.code === 201) || res?.code === 200) {
          toastAlert(
            res?.message ? res?.message : "customer edited successfully",
            "success"
          );
          this.closeEditModal();
          this.getCustomers(this.state.page, this.state.rowsPerPage);
        } else {
          // error
          console.log("error edit customer : ", res, res.message);
          let message =
            res && res.message !== undefined
              ? res.message
              : "Problem while edited Records.";
          toastAlert(message, "error");
          this.closeEditModal();
        }
      } catch (errorr) {
        console.log("error catch block", error);
        toastAlert("Please check Internet Connection.", "error");
        this.closeEditModal();
      }
    }
  };

  handleDropDownChange = (e, val) => {
    this.setState({
      addEmployeeId: val,
    });
  };
  openResetPasswordModal = (data) => {
    this.setState({
      resetPasswordTarget: { id: data?._id, name: data?.name, email: data?.email },
    });
  };

  openDeleteModal = (id) => {
    this.setState({
      deleteId: id,
      showDeleteModal: true,
    });
  };

  deleteCustomer = async () => {
    if (!this?.state?.Orderdata.includes(this.state.deleteId)) {
      const deletedCustomer = await deleteCustomer(
        this.state.deleteId,
        this.props
      );
      toastAlert("customer Deleted successfully", "success");
    } else {
      toastAlert(
        "This Customer delete there are active Task in progress.",
        "error"
      );
    }

    this.setState({
      showDeleteModal: false,
      deleteId: "",
    });
    this.getCustomers(this.state.page, this.state.rowsPerPage);
  };

  setEditCustomer = async (customerId, data) => {
    console.log("Edit Customer : ", customerId, data);
    this.setState({
      editModel: true,
      editError: [],
      editId: customerId,
      editName: data?.name,
      editEmail: data?.email,
      editMobile: data?.mobile,
      editGST: data?.GST,
      editPAN: data?.PAN,
      editCompanyName: data?.companyName,
      editOfficeAddr: data?.officeAddr,
      editEmployeeId: data?.employeeId,
      UserId: data?.userId,
      editTDS: data?.TDS,
    });
  };

  render() {
    const {
      tableData,
      loading,
      employeeData,

      addName,
      addEmail,
      addMobile,
      addGST,
      addPAN,
      addCompanyName,
      addOfficeAddr,
      addPassword,
      addEmployeeId,
      addModel,
      addError,
      addTDS,
      editTDS,
      editName,
      editEmail,
      editMobile,
      editGST,
      editPAN,
      editCompanyName,
      editOfficeAddr,
      editEmployeeId,
      editModel,
      editError,
      _id,
    } = this.state;
    return (
      <div>
        <Grid container>
          <Grid item lg={12} sm={12} xs={12} md={12}>
            {/* Breadcrumb-component : start */}
            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              style={{ marginBottom: "16px" }}
            >
              {/* Breadcrumb : Left */}
              <Grid item>
                <BreadcrumbComp items={this.itemArray()} />
              </Grid>

              {/* Add Customer Button : Right */}
              {hasPermission("create_customer") && (
                <Grid item>
                  <Button
                    className="btn btn-colored"
                    onClick={() => toggleModal(this, this.props)}
                  >
                    + Add New
                  </Button>
                </Grid>
              )}
            </Grid>
            {/* Add Customer Button : end */}

            {/* Add Customer modal : start */}
            <div>
              <Modal className="all-modals" isOpen={addModel} toggle={() => this.closeAddModal()} size="lg">
                <ModalHeader toggle={() => this.closeAddModal()} kicker="Customers">Add customer</ModalHeader>
                <ModalBody>
                  <Grid container spacing={2}>
                    {/* Row 1 */}
                    <Grid item xs={12} sm={6}>
                      <p className="small-text">Customer Name</p>
                      <input
                        className="input-main"
                        type="Text"
                        value={addName}
                        name="addName"
                        onChange={(evt) => handleChange(evt, this)}
                        placeholder="Customer Name"
                      />
                      {addError?.includes("addName") && (
                        <p className="error-message">
                          Customer Name shouldn't be empty
                        </p>
                      )}
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <p className="small-text">Customer Mobile</p>
                      <input
                        className="input-main"
                        type="Number"
                        value={addMobile}
                        name="addMobile"
                        onChange={(evt) => handleChange(evt, this)}
                        placeholder="Customer Mobile No."
                      />
                      {addError?.includes("addMobile") && (
                        <p className="error-message">
                          Customer Mobile No. shouldn't be empty
                        </p>
                      )}
                      {addError?.includes("addmobileregx") && (
                        <p className="error-message">
                          Mobile number must be 10 digits and Enter Valid
                          Mo.Number
                        </p>
                      )}
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <p className="small-text">Company Name</p>
                      <input
                        className="input-main"
                        type="Text"
                        value={addCompanyName}
                        name="addCompanyName"
                        onChange={(evt) => handleChange(evt, this)}
                        placeholder="Company Name"
                      />
                      {addError?.includes("addCompanyName") && (
                        <p className="error-message">
                          Company Name shouldn't be empty
                        </p>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <p className="small-text">Password</p>
                      <PasswordInput
                        value={addPassword}
                        name="addPassword"
                        onChange={(evt) => handleChange(evt, this)}
                        placeholder="Password"
                        autoComplete="new-password"
                      />
                      {addError?.includes("addPassword") && (
                        <p className="error-message">
                          Password shouldn't be empty
                        </p>
                      )}
                      {addError?.includes("adddPasswordregx") && (
                        <p className="error-message">
                          Password must be 8+ characters, include uppercase,
                          lowercase, number & special character,
                        </p>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <p className="small-text">Customer Email</p>
                      <input
                        className="input-main"
                        type="Email"
                        value={addEmail}
                        name="addEmail"
                        onChange={(evt) => handleChange(evt, this)}
                        placeholder="Customer Email Id"
                      />
                      {addError?.includes("addEmail") && (
                        <p className="error-message">
                          Email shouldn't be empty
                        </p>
                      )}
                      {addError?.includes("addemailregx") && (
                        <p className="error-message">
                          Please enter valid Customer email.
                        </p>
                      )}
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <p className="small-text">GST Number</p>
                      <input
                        className="input-main"
                        type="Text"
                        value={addGST}
                        name="addGST"
                        onChange={(evt) => handleChange(evt, this)}
                        placeholder="GST Number"
                      />
                      {addError?.includes("addGST") && (
                        <p className="error-message">
                          GST Number shouldn't be empty
                        </p>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <p className="small-text">TDS</p>
                      <input
                        className="input-main"
                        type="Text"
                        value={addTDS}
                        name="addTDS"
                        onChange={(evt) => handleChange(evt, this)}
                        placeholder="TDS Number"
                      />
                      {addError?.includes("addTDS") && (
                        <p className="error-message">
                          TDS Number shouldn't be empty
                        </p>
                      )}
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <p className="small-text">PAN Number</p>
                      <input
                        className="input-main"
                        type="Text"
                        value={addPAN}
                        name="addPAN"
                        onChange={(evt) => handleChange(evt, this)}
                        placeholder="PAN Number"
                      />
                      {addError?.includes("addPAN") && (
                        <p className="error-message">
                          PAN Number shouldn't be empty
                        </p>
                      )}
                    </Grid>
                    {/* Row 3 */}



                    {/* <Grid item xs={12} sm={4}>
                      <p className="small-text">Assign Employee</p>
                      <Autocomplete
                        name="addEmployeeId"
                        value={addEmployeeId}
                        options={employeeData?.filter(e => e?.userId?._id)}
                        autoHighlight
                        disabled={this?.props?.authData?.role !== "admin"}
                        onChange={(e, val) => this.handleDropDownChange(e, val)}
                        getOptionLabel={(option) => option.name || ""}
                        renderOption={(props, option) => (
                          <Box
                            component="li"
                            sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                            {...props}
                          >
                            {option.name || ""}
                          </Box>
                        )}
                        renderInput={(params) => (
                          <TextField
                            className="country-dropdown"
                            {...params}
                            placeholder="Employee"
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: "new-password",
                            }}
                          />
                        )}
                      />
                      {addError?.includes("addEmployeeId") && (
                        <p className="error-message">
                          Employees shouldn't be empty
                        </p>
                      )}
                    </Grid> */}
                    <Grid item xs={12}>
                      <p className="small-text">Office Address</p>
                      <textarea
                        className="input-main"
                        type="Text"
                        value={addOfficeAddr}
                        name="addOfficeAddr"
                        onChange={(evt) => handleChange(evt, this)}
                        placeholder="Office Address"
                      />
                      {addError?.includes("addOfficeAddr") && (
                        <p className="error-message">
                          Office Address shouldn't be empty
                        </p>
                      )}
                    </Grid>
                  </Grid>
                </ModalBody>

                <ModalFooter>
                  <Button
                    className="btn btn-border"
                    onClick={() => toggleModal(this)}
                  >
                    Cancel
                  </Button>
                  <Button
                    className="btn btn-colored"
                    onClick={() => this.addCustomer()}
                  >
                    Save customer
                  </Button>
                </ModalFooter>
              </Modal>
            </div>
            {/* Add Employee modal : end */}

            {/* Edit Customer modal : start */}
            <div>
              <Modal className="all-modals" isOpen={editModel} toggle={() => this.closeEditModal()} size="lg">
                <ModalHeader toggle={() => this.closeEditModal()} kicker="Customers">Edit customer</ModalHeader>
                <ModalBody>
                  <Grid container spacing={2}>
                    {/* Row 1 */}
                    <Grid item xs={12} sm={6}>
                      <p className="small-text">Customer Name</p>
                      <input
                        className="input-main"
                        type="Text"
                        value={editName}
                        name="editName"
                        onChange={(evt) => handleChange(evt, this)}
                        placeholder="Customer Name"
                      />
                      {editError?.includes("editName") && (
                        <p className="error-message">
                          Customer Name shouldn't be empty
                        </p>
                      )}
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <p className="small-text">Customer Mobile</p>
                      <input
                        className="input-main"
                        type="Number"
                        value={editMobile}
                        name="editMobile"
                        onChange={(evt) => handleChange(evt, this)}
                        placeholder="Customer Mobile No."
                      />
                      {editError?.includes("editMobile") && (
                        <p className="error-message">
                          Customer Mobile No. shouldn't be empty
                        </p>
                      )}
                      {editError?.includes("editmobileregx") && (
                        <p className="error-message">
                          Mobile number must be 10 digits and Enter Valid
                          Mo.Number
                        </p>
                      )}
                    </Grid>

                    {/* Row 2 */}
                    <Grid item xs={12} sm={6}>
                      <p className="small-text">Company Name</p>
                      <input
                        className="input-main"
                        type="Text"
                        value={editCompanyName}
                        name="editCompanyName"
                        onChange={(evt) => handleChange(evt, this)}
                        placeholder="Company Name"
                      />
                      {editError?.includes("editCompanyName") && (
                        <p className="error-message">
                          Company Name shouldn't be empty
                        </p>
                      )}
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <p className="small-text">Customer Email</p>
                      <input
                        className="input-main"
                        type="Email"
                        value={editEmail}
                        name="editEmail"
                        onChange={(evt) => handleChange(evt, this)}
                        placeholder="Customer Email Id"
                      />
                      {editError?.includes("editEmail") && (
                        <p className="error-message">
                          Email shouldn't be empty
                        </p>
                      )}
                      {editError?.includes("editEmailregx") && (
                        <p className="error-message">
                          Please enter valid Customer email.
                        </p>
                      )}
                    </Grid>



                    <Grid item xs={12} sm={6}>
                      <p className="small-text">GST Number</p>
                      <input
                        className="input-main"
                        type="Text"
                        value={editGST}
                        name="editGST"
                        onChange={(evt) => handleChange(evt, this)}
                        placeholder="GST Number"
                      />
                      {editError?.includes("editGST") && (
                        <p className="error-message">
                          GST Number shouldn't be empty
                        </p>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <p className="small-text">TDS</p>
                      <input
                        className="input-main"
                        type="Text"
                        value={editTDS}
                        name="editTDS"
                        onChange={(evt) => handleChange(evt, this)}
                        placeholder="TDS Number"
                      />
                      {editError?.includes("editTDS") && (
                        <p className="error-message">
                          TDS Number shouldn't be empty
                        </p>
                      )}
                    </Grid>
                    <Grid item xs={12}>
                      <p className="small-text">Office Address</p>
                      <textarea
                        className="input-main textarea"
                        value={editOfficeAddr}
                        name="editOfficeAddr"
                        onChange={(evt) => handleChange(evt, this)}
                        placeholder="Office Address"
                      />
                      {editError?.includes("editOfficeAddr") && (
                        <p className="error-message">
                          Office Address shouldn't be empty
                        </p>
                      )}
                    </Grid>
                  </Grid>
                </ModalBody>

                <ModalFooter>
                  <Button
                    className="btn btn-border"
                    onClick={() => toggleEditModal(this)}
                  >
                    Cancel
                  </Button>
                  <Button
                    className="btn btn-colored"
                    onClick={() => this.editCustomer()}
                  >
                    Save changes
                  </Button>
                </ModalFooter>
              </Modal>
            </div>
            {/* Edit Employee modal : end */}

            {/*User_List_section::Start */}
            <Grid container className="data-table-main">
              <Grid item lg={12} sm={12} md={12} xs={12}>
                <div className="card-main" style={{ width: "100%" }}>
                  {loading ? (
                    <CircularProgress style={{ color: "#5F5BA8" }} size={50} />
                  ) : (
                    <Datatable
                      props={tableData}
                      title="All Customers"
                      currentPage={this?.state?.page}
                      TotalRow={this?.state?.count}
                      rowsPerPage={this.state.rowsPerPage}
                      onPageChange={(page, rows) => {
                        this.setState({
                          page: page,
                          rowsPerPage: rows,
                        });
                        this.getCustomers(page, rows);
                      }}
                      onSearchChange={(search) => {
                        this.setState({
                          Searchtax: search,
                          page: 1,
                        });
                        this.getCustomers(1, this.state.rowsPerPage, search);
                      }}
                    />
                  )}
                  <ConfirmDeleteModal
                    open={this.state.showDeleteModal}
                    onClose={() => this.setState({ showDeleteModal: false })}
                    onConfirm={this.deleteCustomer}
                    message="Are you sure you want to delete this Customer?"
                  />
                  <ResetPasswordModal
                    open={Boolean(this.state.resetPasswordTarget)}
                    target={this.state.resetPasswordTarget}
                    onReset={resetCustomerPassword}
                    onClose={() => this.setState({ resetPasswordTarget: null })}
                  />
                </div>
              </Grid>
            </Grid>
            {/*User_List_section::End */}
          </Grid>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  authData: state.authReducer,
});

export default withRouter(connect(mapStateToProps)(CustomerListComponent));
